
namespace DnDUtils {
    export function getDiceGenerator(diceString:string):()=>number {
        diceString = diceString.replace(/(\d*)d(\d+)/g, function(match:string, count:string, dim:string, offset:number){
            if (count == '') {
                count = '1';
            }
            return 'DnDUtils.manyDice(' + count + ',' + dim +')';
        });
        
        let returnable:()=>number = null;
        let funcText =  `
            var result = ${diceString};
            return result;
        `
        
        let evaluator = new Function(funcText);
        returnable = evaluator as ()=>number;
        
        return returnable;
    }
    
    export function manyDice(count:number, dimention:number):number {
        let sum = 0;
        while (count --> 0) {
            sum += (Math.random() * dimention + 1) | 0
        }
        return sum;
    }
    
    export function getTheoreticalMean(diceString:string):number {
        diceString = diceString.replace(/(\d*)d(\d+)/g, function(match:string, count:string, dim:string, offset:number){
            if (count == '') {
                count = '1';
            }
            return 'DnDUtils.getTheoreticalMeanDice(' + count + ',' + dim +')';
        });
        
        let returnable:()=>number = null;
        let funcText =  `
            var result = ${diceString};
            return result;
        `
        new Function(funcText);
        
        return (new Function(funcText))();
    }
    
    export function getTheoreticalMeanDice(count:number, dimention:number):number {
        return count * (dimention + 1) / 2;
    }
    
    export function getMean(results:Array<number>):number {
        let acc = 0;
        let l = results.length;
        for (let i =0; i < l; i++) {
            acc += results[i];
        }
        return acc/l;
    }
    
    /**
     * Дисперсия (сумма квадратов отклонений)
     * @param results 
     * @param mean 
     */
    export function getVariance(results:Array<number>, mean:number = undefined):number {
        if (mean === undefined) {
            mean = getMean(results);
        }
        let acc = 0;
        let l = results.length;
        for (let i =0; i < l; i++) {
            let delta = mean - results[i];
            acc += delta * delta / l;
        }
        return acc;
    }
    
    export function getGaussDenc(M:number, sigma:number, x:number) {
        let first = 1 / (sigma * Math.sqrt(2*Math.PI));
        let pow = -((x-M)*(x-M))/(2*sigma*sigma);
        return first * Math.exp(pow);
        
    }
    
    export function getPearsonDistance(calcDenc:{[key:string]:number}, refDenc:{[key:string]:number}):number {
        let keys = Object.keys(calcDenc).concat(Object.keys(refDenc)).map(v=>parseInt(v));
        let min = ArrayUtils.min(keys);
        let max = ArrayUtils.max(keys);
        let acc = 0;
        for (let i = 0 ; i <= max; i++) {
            let calc = calcDenc[i] || 0;
            let ref = refDenc[i] || 0;
            let delta = calc - ref;
            acc += delta * delta / ref;
        }
        return Math.sqrt(acc);
    }
    
    export function getBinomDistribAtPoint(M:number, D:number, x:number):number {
        // M == np
        // D == npq
        let q = D/M;
        let p = 1-q;
        let n = Math.round(M / p);
        
        return cnk(n, x) * Math.pow(p, x) * Math.pow(q, n-x) * n;
    }
    
    export function cnk(n:number, k:number):number {
        let nmk = n - k;
        if (k > nmk) {
            return factorMult(k+1, n)/factorMult(1, nmk);
        } else {
            return factorMult(nmk+1, n)/factorMult(1, k);
        }
    }
    
    export function factorMult(from:number, to:number):number {
        let acc = 1;
        for (let i = from; i <= to; i++) {
            acc *= i;
        }
        return acc;
    }
    
    export function clamp(value:number, min:number, max:number) {
        if (value < min) {
           return min;
        }
        if (value > max) {
            return max;
        }
        return value;
    }
}